/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Ical_AltInputs */

const cs_settings_profile_ical_alt = /** @type {(inputs: Settings_Profile_Ical_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemáte Google/Microsoft? Odebírejte iCal — jednosměrně, jen vaše úkoly.`)
};

const en_settings_profile_ical_alt = /** @type {(inputs: Settings_Profile_Ical_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Google/Microsoft account? Subscribe with iCal instead — one-way, your tasks only.`)
};

/**
* | output |
* | --- |
* | "No Google/Microsoft account? Subscribe with iCal instead — one-way, your tasks only." |
*
* @param {Settings_Profile_Ical_AltInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_ical_alt = /** @type {((inputs?: Settings_Profile_Ical_AltInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Ical_AltInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_ical_alt(inputs)
	return cs_settings_profile_ical_alt(inputs)
});